import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';

export default class Instagram extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '16px',
    strokeColor: '#333333',
    width: '16px',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 16 16"
        width={width}
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-116.000000, -320.000000)" fill={strokeColor}>
            <g transform="translate(28.000000, 320.000000)">
              <path d="M102.098137,0 L89.9018629,0 C88.8514306,0 88,0.849248561 88,1.89749884 L88,14.1025012 C88,15.150315 88.8514306,16 89.9018629,16 L102.098137,16 C103.148569,16 104,15.150315 104,14.1025012 L104,1.89749884 C104,0.849248561 103.148569,0 102.098137,0 L102.098137,0 Z M99.5002046,2.49974088 C99.5002046,2.22393148 99.7240815,2.00005455 99.9998909,2.00005455 L101.499823,2.00005455 C101.776069,2.00005455 101.999945,2.22393148 101.999945,2.49974088 L101.999945,4.0001091 C101.999945,4.2759185 101.776069,4.49979543 101.499823,4.49979543 L99.9998909,4.49979543 C99.7240815,4.49979543 99.5002046,4.2759185 99.5002046,4.0001091 L99.5002046,2.49974088 L99.5002046,2.49974088 Z M96.0185473,4.94885852 C97.7179172,4.94885852 99.095655,6.32354145 99.095655,8.01854731 C99.095655,9.71398958 97.7179172,11.0882361 96.0185473,11.0882361 C94.3196138,11.0882361 92.941876,9.71398958 92.941876,8.01854731 C92.941876,6.32354145 94.3196138,4.94885852 96.0185473,4.94885852 L96.0185473,4.94885852 Z M102.500068,13.9999454 C102.500068,14.2757548 102.276191,14.5000682 101.999945,14.5000682 L90.0000546,14.5000682 C89.7238087,14.5000682 89.4999318,14.2757548 89.4999318,13.9999454 L89.4999318,6.49984998 L91.4999864,6.49984998 C91.2394512,6.87472384 91.1512969,7.5742847 91.1512969,8.01854731 C91.1512969,10.695906 93.335079,12.8744511 96.0185473,12.8744511 C98.7024521,12.8744511 100.886234,10.695906 100.886234,8.01854731 C100.886234,7.5742847 100.822955,6.88563402 100.500014,6.49984998 L102.500068,6.49984998 L102.500068,13.9999454 L102.500068,13.9999454 Z" />
            </g>
          </g>
        </g>
      </SVGElement>
    );
  }
}
